<ng-container>
  <h2 mat-dialog-title>Sélection d’engagements existants</h2>
  <div class="mt-1" style="display: flex; align-items: center; gap: 6px; font-size: 12px; color: rgba(0, 0, 0, 0.72)">
    <span style="font-weight: 600">(!)</span>
    <span>
      Si un engagement manque à cette liste, assurez-vous d'avoir ajouté sa catégorie d'article dans les Familles
      d'achats couvertes par votre établissement.
    </span>
  </div>
  <hr />
  <mat-dialog-content>
    <vex-engagement-select
      [supportEstablishment]="data.supportEstablishment"
      [currentEngagement]="data.engagement"
      [selectedEngagements]="data.selectedEngagements"
      #table
    ></vex-engagement-select>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <app-legend [legendItems]="table.legendData"></app-legend>
    <div>
      <button mat-button (click)="closeDialog()">Annuler</button>
      <button mat-button color="primary" [disabled]="!table.hasSelection()" (click)="validate()">Valider</button>
    </div>
  </mat-dialog-actions>
</ng-container>
